import api from './api';

export interface PortfolioSettingsDto {
  slug: string;
  slugLocked: boolean;
  headline?: string | null;
  aboutText?: string | null;
  introVideoUrl?: string | null;
  pricingText?: string | null;
  ctaText?: string | null;
  isPublished: boolean;
}

export interface UpdatePortfolioSettingsRequest {
  slug: string;
  headline?: string;
  aboutText?: string;
  introVideoUrl?: string;
  pricingText?: string;
  ctaText?: string;
  isPublished: boolean;
}

export interface PortfolioAccessRequestDto {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  message?: string | null;
  status: 'pending' | 'approved' | 'denied';
  decisionNote?: string | null;
  invitationUrl?: string | null;
  processedAt?: string | null;
  createdAt: string;
}

export interface PortfolioBlogPostDto {
  id: string;
  tenantId?: string | null;
  slug: string;
  title: string;
  excerpt?: string | null;
  body?: string | null;
  featuredImageUrl?: string | null;
  isPublished: boolean;
  publishedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePortfolioBlogPostRequest {
  slug?: string;
  title: string;
  excerpt?: string;
  body?: string;
  featuredImageUrl?: string;
  isPublished: boolean;
}

export interface UpdatePortfolioBlogPostRequest {
  title?: string;
  excerpt?: string;
  body?: string;
  featuredImageUrl?: string;
  isPublished?: boolean;
}

export const portfolioService = {
  async getMyPortfolio(): Promise<PortfolioSettingsDto> {
    const response = await api.get<PortfolioSettingsDto>('/portfolio/me');
    return response.data;
  },

  async saveMyPortfolio(payload: UpdatePortfolioSettingsRequest): Promise<PortfolioSettingsDto> {
    const response = await api.put<PortfolioSettingsDto>('/portfolio/me', payload);
    return response.data;
  },

  async getAccessRequests(): Promise<PortfolioAccessRequestDto[]> {
    const response = await api.get<PortfolioAccessRequestDto[]>('/portfolio/me/access-requests');
    return Array.isArray(response.data) ? response.data : [];
  },

  async approveAccessRequest(id: string, note?: string): Promise<PortfolioAccessRequestDto> {
    const response = await api.post<PortfolioAccessRequestDto>(`/portfolio/me/access-requests/${id}/approve`, {
      note,
    });
    return response.data;
  },

  async denyAccessRequest(id: string, note?: string): Promise<PortfolioAccessRequestDto> {
    const response = await api.post<PortfolioAccessRequestDto>(`/portfolio/me/access-requests/${id}/deny`, {
      note,
    });
    return response.data;
  },

  async listBlogPosts(): Promise<PortfolioBlogPostDto[]> {
    const response = await api.get<PortfolioBlogPostDto[]>('/portfolio/me/blog-posts');
    return Array.isArray(response.data) ? response.data : [];
  },

  async createBlogPost(payload: CreatePortfolioBlogPostRequest): Promise<PortfolioBlogPostDto> {
    const response = await api.post<PortfolioBlogPostDto>('/portfolio/me/blog-posts', payload);
    return response.data;
  },

  async updateBlogPost(id: string, payload: UpdatePortfolioBlogPostRequest): Promise<PortfolioBlogPostDto> {
    const response = await api.put<PortfolioBlogPostDto>(`/portfolio/me/blog-posts/${id}`, payload);
    return response.data;
  },

  async deleteBlogPost(id: string): Promise<void> {
    await api.delete(`/portfolio/me/blog-posts/${id}`);
  },
};
